import { Tag } from 'antd';
import styled from 'styled-components';

export const CTag = styled(Tag)<{
  color?: string;
  height?: string;
  margin?: number;
  borderRadius?: string;
}>`
  background-color: ${props => `${props?.color}16 !important`};
  position: relative;
  display: flex;
  height: ${p => p.height || '24px'};
  align-items: center;
  margin-right: 0px;
  margin-bottom: ${p => p.margin}px;
  cursor: pointer;
  max-width: 240px;
  width: fit-content;
  flex-shrink: 0;
  font-size: ${props => props.theme.font.size.xxs};
  font-weight: ${props => props.theme.font.weight.medium};
  border-radius: ${p => p.borderRadius || p.theme.radius.md};
  border: none;

  .text {
    color: ${props => `${props?.color}!important`};
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
`;
